import {useState}  from 'react';
import NormalBtn from '../StockItems/NormalBtn';
import * as CoreFns from '../utilities/CoreFns';
import * as SharedAcross from '../utilities/SharedAcross';
import * as ServerComms from '../utilities/ServerComms';

function App(props) {

  var tempAddr = props.tempAddr;
  var signKey = props.signKey;
  var userID = props.userID;
  var sessionID = props.sessionID;
  var chainId = props.chainId;
  var chains = props.chains;
  var postEffects = props.postEffects;

  const [isLoading, setIsLoading] = useState(false);
  const [textText, setTextText] = useState('');
  const [isManual, setIsManual] = useState(false);

  // function postSucceed(thisItem){
  //   setIsLoading(false);
  //   doPost(thisItem);
  // }

  function postSucceed(postEffects, liveContractAddress1){
    return function(thisItem){
      var gotImplementation = false;
      var abi = JSON.parse(thisItem.ABI);
      for (var i = 0; i < abi.length; i++){
        if (abi[i].name === 'implementation'){
          gotImplementation = true;
          break;
        }
      }            

      if (gotImplementation){

        var bSet = CoreFns.getInfoFromChains(chainId, 'b', chains);
        var proxyAddress = window.prompt('This looks like a proxy contract. Pleaes go to '+bSet[0]+ '/address/' + liveContractAddress1+'#code to find the proxy address, and enter it here.');

        if (proxyAddress){

          function recoverHere(){

          }

          function postFail(message){
            if (message === 'NotUploaded'){
              message = 'No contract found at ' + proxyAddress + ' on the ' + CoreFns.getInfoFromChains(chainId, 'n', chains) + ' chain';
            }
            window.alert(message);
          }

          function postEffects1(item2){
            thisItem.ABI = item2.ABI;
            postEffects(thisItem);
          }
          fetchContractInfo(proxyAddress, chainId, userID, sessionID, signKey, postSucceed(postEffects1, proxyAddress), postFail, chains, recoverHere);

        }

      }else{
        postEffects(thisItem);
      }
      
      setIsLoading(false);      
    }
  }

  function postFail1(message){
    window.alert(message);
    setIsLoading(false);
  }

  function clickSubmit(e){
    if (!isLoading){
      if (!SharedAcross.isEthAddress (tempAddr)){
        window.alert('Invalid Address');
      }else{
        setIsLoading(true);

        function doManualInput(){
          setIsManual(true);
          setTextText('');
        }

        fetchContractInfo(tempAddr, chainId,  userID, sessionID, signKey, postSucceed(postEffects, tempAddr), postFail1, chains, doManualInput);
      }
    }
  }


  if (isManual){

    function onChange(e){
      setTextText(e.target.value);
    }

    var relevantChain = CoreFns.getRelevantChain(chainId, chains);

    var specAdd = relevantChain.b[0]+'/address/' + tempAddr + '#code';

    function clickText(){
      try{
        var abi = JSON.parse(textText);
        var x1 = window.prompt('What is the name of the contract? You can find it at '+specAdd);
        if (x1){
            var disallowed = [' ', '(', ')', '{', '}'];
            disallowed.forEach((aP, index)=>{
                x1 = x1.split(aP).join('');
            })
            var thisI = {ContractName:x1, ABI:JSON.stringify(abi)};
            if (postSucceed){
                postSucceed(postEffects, tempAddr)(thisI);
            }
        }
      }catch(err){
        window.alert('Oops, the ABI was not in a valid JSON format.')
      } 
      setIsLoading(false);
    }

    function cancelText(){
      setIsLoading(false);
    }

    function copyText(){
      window.open(specAdd);
    }

    return <div>
              <span>Please go to <span style={{textDecoration:'underline', cursor:'pointer'}} onClick={copyText}>[here]</span> and copy the Contract ABI section and paste it here. Or, if the contract is a proxy contract, paste in the ABI of the contract it is a proxy for.</span><br/>
              <textarea rows="10" className='inputBoxClass' value={textText} onChange={onChange} style={{width:'80%'}} placeholder='' /><br/>
              <NormalBtn title='Submit' onClick={clickText} backScreen={true}/><br/><NormalBtn onClick={cancelText} backScreen={true} title='Cancel' />
          </div>

  }else if (isLoading){
    return <div>Verifying...</div>
  }else{
    return <NormalBtn icon='mdi:rocket-launch-outline' backScreen={true} title='Confirm' onClick={clickSubmit} />
  }

//



}

function fetchContractInfo(addIn, chainId, userID, sessionID, signKey, postSucceed, postFail, chains, doManualInput){


    var relevantChain = CoreFns.getRelevantChain(chainId, chains);

    var url = relevantChain.u + addIn;

    if (chainId === 324){
        var p = window.prompt('Please go to https://explorer.zksync.io/address/' + addIn + ' and cut and paste the contract text here');
        function xx(response){
            if (response.t === 'string'){
                if (response.v.indexOf('Error') === 0){
                    if (postFail){
                        postFail(response.v);
                    }
                    return;
                }

                var pieces = response.v.split('======= /root/sol_files_for_abi/test');
                var x15;
                var titleX;
                var titles = [];
                for (var i5 = 1; i5 < pieces.length; i5++){
                    var thisPiece = pieces[i5];
                    var semiColonIndex = thisPiece.indexOf(':');
                    var beyondSemiColon = thisPiece.substr(semiColonIndex + 1);
                    var locOfDashes = beyondSemiColon.indexOf(' =======');
                    var title = beyondSemiColon.substr(0, locOfDashes);
                    titles.push(title);
                }
                var tgt;
                if (titles.length === 1){
                    titleX = titles[0];
                    tgt = 1;
                }else{
                    var msg = 'Please enter the number of the contract you are using \n\n' + titles.map((aTitle, index)=>{
                        return ' ('+(index+1)+') ' + aTitle;
                    }).join('\n');
                    var p5 = window.prompt(msg);
                    if (+p5 > 0){
                        tgt = +p5;
                        titleX = titles[+p5-1];
                    }else{
                        if (postFail){
                            postFail('Please enter a number between 1 and ' + (titles.length));
                        }
                        return;
                    }

                }                    
                var thisPieceX = pieces[tgt];
                var indexOfComparator = thisPieceX.indexOf('Contract JSON ABI');
                if (indexOfComparator > -1){
                    x15 = thisPieceX.substr(indexOfComparator + 17);
                }else{
                    console.log(thisPieceX);
                    return;
                }
                
                try{
                    var abi = JSON.parse(x15);
                    var thisI = {ContractName:titleX.split(' ').join(''), ABI:JSON.stringify(abi)};
                    if (postSucceed){
                        postSucceed(thisI);
                    }

                }catch(err){
                    if (postFail){
                        postFail('Oops, the ABI was not in a valid JSON format.');
                    }
                }                    
            }else{
                if (postFail){
                    postFail('Invalid Contract');
                }
            }
        }
        if (p){
            ServerComms.fetchSomething({u:'solcCompile', contractInfo:p, userID, signKey, sessionID}, xx);
        }

    }else if (chainId === 1116 || chainId === 1115){

        doManualInput();
    }else if (url.indexOf('https://api.hecoinfo.com') === 0 || url.indexOf('https://api-testnet.hecoinfo.com/') === 0){
        function postGetTemplates1(response){
            try{
                var jsonOut = JSON.parse(response.v[1].v);
                postSucceed(jsonOut.result)
            }catch(err){
                console.log(err);
            }
        }
        ServerComms.fetchSomething({u:'getUrl', page:url}, postGetTemplates1);
    }else{
        fetch(url)
          .then(function(response){
            return response.json();
          })
          .then(function(json){
            if (json.message === 'NOTOK' ){
                if (json.result === 'Contract source code not verified'){
                    doManualInput();
                }else{

                    setTimeout(function(){ fetchContractInfo(addIn, chainId,  userID, sessionID, signKey, postSucceed, postFail, chains, doManualInput); }, 3001);
                    window.alert('Maximum scan query rate reached, trying again in 5 seconds');
                }
            }else if (json.message.indexOf('OK') === 0){
              var thisItem = json.result[0];
              if (thisItem.ContractName){
                if (postSucceed){
                  postSucceed(thisItem);
                }
              }else{
                doManualInput();
              }
            }else{
                if (json.message.indexOf('not verified') > -1){
                    doManualInput();
                }else{
                    if (postFail){
                      postFail(json.message);
                    }
                }
            }
            // setJson(json);
          })
          .catch(error => {
            var message = error.message;
            if (postFail){
              postFail(message);
            }
          });
    }
  }    


export default App;
